import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useRouteMatch } from 'react-router-dom';
import { Popconfirm, Input, Space } from 'antd';
import Button from '@iso/components/uielements/button';
import Highlighter from 'react-highlight-words';
import notification from '@iso/components/Notification';
import HelperText from '@iso/components/utility/helper-text';
import LayoutWrapper from '@iso/components/utility/layoutWrapper';
import PageTitleBar from '@iso/components/utility/PageTitleBar';
import FormWindow from '@iso/containers/Dashboard/FormWindow';
import EditPaymentForm from './EditPaymentForm';
import paymentFormActions from '@iso/redux/paymentForm/actions';
import CardWrapper, { Box, StatusTag } from './allList.style';
import Scrollbars from '@iso/components/utility/customScrollBar';
import TableWrapper from '../../Tables/AntTables/AntTables.styles';
import apiActivity from '@iso/services/repository/activity';
import { b64_to_utf8 } from '@iso/lib/helpers/utility';
import Loader from '@iso/components/utility/loader';
import { SearchOutlined, PlusOutlined } from '@ant-design/icons';

const { initData, deletePaymentForm } = paymentFormActions;

export default function PaymentForms() {
	const ses = sessionStorage.getItem("permissions");
	const arraySplit = b64_to_utf8(ses).split(",");
  const [selected, setSelected] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const { initialPaymentsForm, paymentForms } = useSelector((state) => state.PaymentForms);
  const dispatch = useDispatch();
  const match = useRouteMatch();
  const searchInput = useRef(null);

  useEffect(() => {
    if (!initialPaymentsForm)
      dispatch(initData());
  }, [dispatch, initialPaymentsForm]);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = (dataIndex, collum) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, collum)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, collum)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Limpar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Fechar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        title={"Pesquisar pelo "+dataIndex+" da Forma de Pagamento"}
        style={{
          color: '#000000',
        }}
      />
    ),
    onFilter: (value, record) =>
      record[collum].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === collum ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: 'Nome',
      dataIndex: 'name',
      key: 'name',
      width: '75%',
      render: (text) => <span>{text}</span>,
      ...getColumnSearchProps('Nome', 'name')
    },
    {
      title: 'Status',
      dataIndex: 'situation',
      key: 'situation',
      width: '25%',
      render: (text) => {
        let className;
        if (text === 'ativo' || text === 'Ativo' || text === 'ATIVO') {
          className = 'ativo';
        } else if ( text === 'inativo' || text === 'Inativo' || text === 'INATIVO' ) {
          className = 'inativo';
        }
        return <StatusTag className={className}>{text}</StatusTag>;
      },
    },
    {
      title: '',
      dataIndex: 'view',
      rowKey: 'view',
      width: '10%',
      render: (_, paymentForm) => (
        <div className="isoPaymentFormBtnView">
          {arraySplit.includes('Forma_Pagamento_editar') || arraySplit.includes('all')  ? 
            <a href={`${match.path}/${paymentForm._id}`} onClick={(event) => { event.preventDefault(); setEditingId(paymentForm._id); }}>
              <Button color="primary" className="viewBtn">
                Editar
              </Button>
            </a>
          : ''}
          {arraySplit.includes('Forma_Pagamento_excluir') || arraySplit.includes('all')  ? 
            <Popconfirm title="Deseja realmente deletar?" onConfirm={() => {
              apiActivity
                .getByParameter('condicaoComercial.paymentForm', paymentForm._id)
                .then(
                  (response) => {
                    if(response.data.length > 0){
                      notification('error', 'Forma de Pagamento está sendo usado na(s) Atividade(s)');
                    } else {
                        const index = paymentForms.map(inv => inv._id).indexOf(paymentForm._id);
                        dispatch(deletePaymentForm(paymentForms[index]._id));
                        notification('success', '1 forma de pagamento deletada');
                      }
                    }
                  )
                  .catch((err) => {
                    console.error("ops! ocorreu um erro" + err);
                  });
            }}>
              <Button className="dltBtn" onClick={() => { }}>
                <i className="ion-android-delete" />
              </Button>
            </Popconfirm>
          : ''}
        </div>
      ),
    },
  ];

  const rowSelection = {
    hideDefaultSelections: true,
    selectedRowKeys: selected,
    onChange: (selected) => setSelected(selected),
    selections: [
      {
        rowKey: 'all-data',
        text: 'Selecionar todos',
        onSelect: () => setSelected(paymentForms.map((paymentForm) => paymentForm._id)),
      },
      {
        rowKey: 'no-data',
        text: 'Desselecionar',
        onSelect: () => setSelected([]),
      }
    ],
    onSelection: (selected) => setSelected(selected),
  };

  return (
    <LayoutWrapper>
      
      <PageTitleBar title="Formas de Pagamento" />
      <div style={{ backgroundColor: '#fff', padding: '0 16px 12px 16px', marginBottom: 10, display: 'flex', gap: 8, justifyContent: 'flex-end', width: '100%' }}>
        <Link to={`${match.path}/0`}>
          <Button type="primary" className="mateAddBtn">
            Adicionar
          </Button>
        </Link>
      </div>
      <Box style={{ border: 'none', boxShadow: 'none' }}>
        {!initialPaymentsForm ? (
          <Loader />
        ) : (
          <CardWrapper>
            {paymentForms !== undefined && paymentForms.length === 0 ? (
              <HelperText text="Sem Forma de Pagamento" />
            ) : (
              <div className="isoTable">
                <div
                  style={{ width: '100%' }}
                >
                  <TableWrapper
                    rowKey={"_id"}
                    rowSelection={rowSelection}
                    dataSource={paymentForms}
                    columns={columns}
                    pagination={{ defaultPageSize: 20, showSizeChanger: true, pageSizeOptions: ['10', '20', '50', '100'] }}
                    className="listTable"
                  />
                </div>
              </div>
            )}
          </CardWrapper>
        )}
      </Box>
          <FormWindow
        open={editingId !== null}
        title={editingId === '0' ? 'Cadastro de Forma de Pagamento' : 'Edicao de Forma de Pagamento'}
        onClose={() => setEditingId(null)}
      >
        {({ footerEl }) =>
          editingId !== null ? (
            <EditPaymentForm
              paymentFormId={editingId}
              inModal
              footerEl={footerEl}
              onCancel={() => setEditingId(null)}
              onSaved={() => {
                setEditingId(null);
                dispatch(initData());
              }}
            />
          ) : null
        }
      </FormWindow>
    </LayoutWrapper>
  );
}
